// extracted by mini-css-extract-plugin
export default {"ellipsis":"Q3o257emS7wQylF1X5Ww","wrapper":"BcoXLUQL1npkKRwuDzQ5","colRow":"o5RS8trFhdYtkI0AiJEt","details":"dIwXcDF3F09dSaVUvsav","spin":"Tvc5w1PODsFkInh2l9cb"};